import ExpensesLangFactory from "@bokio/lang/ExpensesLangFactory";

import * as styles from "./receiptDescription.scss";

interface ReceiptDescriptionProps {
	description: string;
}
export const ReceiptDescription = ({ description }: ReceiptDescriptionProps) => {
	const expensesLang = ExpensesLangFactory();
	return (
		<div className={styles.description}>
			<label className={styles.label}>{expensesLang.Description_label}</label>
			<p className={styles.p}>{description}</p>
		</div>
	);
};
